import React from 'react';
import styled from 'styled-components';

export default class Cross extends React.PureComponent {

	render() {
		return (
			<CrossWrapper className="ps-cross" alignItems={this.props.alignItems} justifyContent={this.props.justifyContent}>
				{this.props.children}
			</CrossWrapper>
		);
	}
}

const CrossWrapper = styled.div`
	align-items: ${props => props.alignItems} !important;
	justify-content: ${props => props.justifyContent};
`;